import { promocodeMessages } from './messages'

export const E_COUPON_EXPIRED = 'E_COUPON_EXPIRED'
export const E_COUPON_INVALID = 'E_COUPON_INVALID'
export const E_COUPON_USED = 'E_COUPON_USED'

export type errorCode =
  | typeof E_COUPON_EXPIRED
  | typeof E_COUPON_INVALID
  | typeof E_COUPON_USED

export const promocodeFieldError = {
  E_COUPON_USED: promocodeMessages.promocodeUsed,
  E_COUPON_EXPIRED: promocodeMessages.promocodeExpired,
  E_COUPON_INVALID: promocodeMessages.promocodeInvalid,
}
